'use client'

import { memo } from 'react'

import { ErrorServiceUnavailable } from '@/components/common/Error'

const ChartOverviewMyBorrowError = () => {
  return (
    <div data-testid="market-my-borrow-chart-error">
      <ErrorServiceUnavailable minHeight="395px" />
    </div>
  )
}

export default memo(ChartOverviewMyBorrowError)
